import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import * as moment from "moment-timezone";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { Http, Headers } from "@angular/http";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
@Injectable({
  providedIn: "root",
})
export class AppService {
  authcontextpath = "schedMedLogin";
  profilecontextpath = "schedMedProfile";
  generalcontextpath = "schedMedGeneral";
  schedulecontextpath = "schedMedSchedule";
  paycontextpath = "schedMedPay";
  notificationcontextpath = "schedMedNotification";
  currentDate = new Date();
  private pdfHttp: HttpClient;

  constructor(
    private http: HttpClient,
    private https: Http,
    private router: Router,
    private datepipe: DatePipe,
    private httpBackend: HttpBackend
  ) {
    this.pdfHttp = new HttpClient(this.httpBackend);
  }

  private authHeader() {
    return new HttpHeaders({
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
    });
  }

  private authJsonHeaderLowerAfter() {
    return new HttpHeaders({
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
      "content-Type": "application/json",
    });
  }

  private contentTypeAuthHeader() {
    return new HttpHeaders({
      ContentType: "application/json",
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
    });
  }

  private jsonLowerAuthHeader() {
    return new HttpHeaders({
      "content-Type": "application/json",
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
    });
  }

  private authJsonHeaderUpperAfter() {
    return new HttpHeaders({
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
      "Content-Type": "application/json",
    });
  }

  private jsonUpperAuthHeader() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "bearer " + localStorage.getItem("accesstoken"),
    });
  }

  getlang() {
    return this.http.get("assets/language/English.json");
  }

  navigation(url) {
    if (url) {
      this.router.navigate(["/" + url]);
    }
  }



  getAddressFromGoogle(lat, lng) {
    return this.http.get(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
      lat +
      "," +
      lng +
      "&key=" +
      environment.googleKey
    );
  }

  getAddressBasedonAddress(address) {
    return this.http.get(
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      address +
      "&key=" +
      environment.googleKey
    );
  }

  trigersmsandemail(id) {
    const header = this.jsonUpperAuthHeader();
    return this.http
      .post(
        environment.resourceURL +
        this.schedulecontextpath +
        "/confirmschedmailandsms?id=" +
        id,
        {},
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getCurrentIPAddress() {
    return this.http.get("https://jsonip.com/");
  }

  getAddressBasedonCurrentIp(ip) {
    return this.http.get("https://ip-api.com/json/" + ip);
  }

  checkTechnicianUsername(username) {
    const header = this.jsonUpperAuthHeader();
    return this.http
      .post(
        environment.resourceURL +
        this.profilecontextpath +
        "/checktechnicianusername?username=" +
        username,
        {},
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  checkTechnician(email) {
    const header = this.jsonUpperAuthHeader();
    return this.http
      .post(
        environment.resourceURL +
        this.profilecontextpath +
        "/checktechnician?email=" +
        email,
        {},
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  forgotPassword(email: any[]) {
    const header = new HttpHeaders();
    return this.http.post(
      environment.resourceURL + this.authcontextpath + "/ForgotPassword",
      email,
      { headers: header }
    );
  }

  signout() {
    this.router.navigate(["/login"]);
    sessionStorage.clear();
    const email = localStorage.getItem('email');
    const password = localStorage.getItem('password');
    localStorage.clear();
    if (email) {
      localStorage.setItem('email', email);
    }
    if (password) {
      localStorage.setItem('password', password);
    }
  }

  converttojson(data): any {
    return data.json();
  }

  sessionOut(err) {
    if (err && (err.status == 401 || err.status == "401")) {
      this.router.navigate(["/login"]);
      sessionStorage.clear();
      localStorage.removeItem("accesstoken");
      localStorage.removeItem("testCode");
      localStorage.removeItem("accessmanagement");
      sessionStorage.removeItem("scheduleData");
      localStorage.removeItem("fc_id");
    }
  }

  mapApiCountryId(countryId: any): number | "" {
    if (countryId == null || countryId === "") {
      return "";
    }
    const id = String(countryId);
    if (id === "1" || id === "101" || id === "IN") {
      return 1;
    }
    if (id === "2" || id === "231" || id === "US") {
      return 2;
    }
    const n = Number(countryId);
    return n === 1 || n === 2 ? n : "";
  }

  private mapInsuranceApiCountryId(countryId: any): number {
    const mapped = this.mapApiCountryId(countryId);
    return mapped === "" ? 2 : (mapped as number);
  }

  loginService(data) {
    const params = new HttpParams()
      .set("username", data.email)
      .set("password", data.password)
      .set("grant_type", "password");
    return this.http.post(
      environment.resourceURL + this.authcontextpath + "/login",
      params
    );
  }

  generateLink(data) {
    const header = new HttpHeaders();
    header.append("Content-Type", "application/json");
    return this.http
      .post(
        environment.resourceURL + this.authcontextpath + "/generatelink",
        data,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  generateMobileAppLink(technicianId, phoneNum) {
    const header = this.authHeader();
    return this.http
      .get(
        environment.resourceURL +
        this.profilecontextpath +
        "/generatesmstechnician?technicianId=" +
        technicianId +
        "&phoneNum=" +
        phoneNum,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  generateemailtofrontdesk(frontdeskId, email) {
    const header = this.authHeader();
    return this.http
      .get(
        environment.resourceURL +
        this.profilecontextpath +
        "/generateemailtofrontdesk?frontdeskId=" +
        frontdeskId +
        "&email=" +
        email,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  generatelinktofrontdesk(frontdeskId, type) {
    const header = this.authHeader();
    return this.http
      .get(
        environment.resourceURL +
        this.profilecontextpath +
        "/generatelinktofrontdesk?frontdeskId=" +
        frontdeskId +
        "&type=" +
        type,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getschedinsurancelistbytype(patientid, tcId, type) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {};
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http
      .get(
        environment.resourceURL +
        this.schedulecontextpath +
        "/getschedinsurancelistbytype?id=" +
        patientid +
        "&tcId=" +
        tcId +
        "&type=" +
        type,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getpatientsbyphysicianid(data) {
    const header = this.authHeader();
    return this.http
      .get(
        environment.resourceURL +
        this.schedulecontextpath +
        "/getpatientsbyphysicianid?physicianId=" +
        data.physicianId +
        "&pageNumber=" +
        data.pagenumber +
        "&pageRecord=" +
        data.pagesize +
        "&search=" +
        data.search,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  generatelinktotechnician(techId, type) {
    const header = this.authHeader();
    return this.http
      .get(
        environment.resourceURL +
        this.profilecontextpath +
        "/generatelinktotechnician?techId=" +
        techId +
        "&type=" +
        type,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  verifyLink(data) {
    const header = new HttpHeaders();
    header.append("Content-Type", "application/json");
    return this.http
      .post(
        environment.resourceURL + this.authcontextpath + "/verificationlink",
        data,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }


  checkLink(data) {
    const header = new HttpHeaders();
    header.append("Content-Type", "application/json");
    return this.http
      .post(
        environment.resourceURL + this.authcontextpath + "/checklink",
        data,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  resetPassword(data) {
    const header = new HttpHeaders();
    header.append("Content-Type", "application/json");
    return this.http
      .post(
        environment.resourceURL + this.authcontextpath + "/forgotpassword",
        data,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  userregister(data) {
    const header = new HttpHeaders();
    header.append("Content-Type", "application/json");
    return this.http.post(
      environment.resourceURL + this.authcontextpath + "/register",
      data,
      { headers: header }
    );
  }

  viewtestcenter() {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/viewtestcenter",
      {},
      { headers: header }
    );
  }

  viewtestcenterwithdata(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/viewtestcenter",
      data,
      { headers: header }
    );
  }
  revoke() {
    const header = this.authHeader();
    return this.http.put(
      environment.resourceURL + this.authcontextpath + "/revoke",
      null,
      { headers: header }
    );
  }

  getCountry() {
    return this.http.get(
      environment.resourceURL + this.generalcontextpath + "/getallcountry"
    );
  }

  getState(countryid) {
    const mappedCountryId = this.mapApiCountryId(countryid);
    const countryId = mappedCountryId === "" ? countryid : mappedCountryId;
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallstate?countryId=" +
      countryId
    );
  }

  getHolidayList(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallholidaysbytcidandcountryid?testCenterId=" +
      data.testCenterId +
      "&countryId=" +
      data.countryId +
      "&year=" +
      data.year,
      { headers: header }
    );
  }

  getParkingList() {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL + this.generalcontextpath + "/getallparking",
      { headers: header }
    );
  }

  chkLength(data) {
    if (data.toString().length == 1) {
      return "0" + data.toString();
    } else {
      return data;
    }
  }

  setLocaldatetime(date, time): string {
    let now_utc1;
    let local;
    if (date && time) {
      const now1 = new Date(date + " " + time);
      local = moment(now1)
        .subtract(this.currentDate.getTimezoneOffset(), "m")
        .toDate();
      now_utc1 =
        local.getFullYear() +
        "-" +
        this.chkLength(local.getMonth() + 1) +
        "-" +
        this.chkLength(local.getDate()) +
        " " +
        this.chkLength(local.getHours()) +
        ":" +
        this.chkLength(local.getMinutes());
    } else {
      now_utc1 = "";
      return "0";
    }
    return now_utc1;
  }

  updateBasicProfile(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.put(
      environment.resourceURL + this.profilecontextpath + "/updatebasicinfo",
      data,
      { headers: header }
    );
  }

  changepassword(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.put(
      environment.resourceURL + this.authcontextpath + "/changepassword",
      data,
      { headers: header }
    );
  }

  getCity(stateid) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallcity?stateId=" +
      stateid,
      { headers: header }
    );
  }

  getAllExams() {
    return this.http.get(
      environment.resourceURL + this.generalcontextpath + "/getallexams"
    );
  }

  getAllExamswithoutMRAandCTA() {
    return this.http.get(
      environment.resourceURL + this.generalcontextpath + "/getexams"
    );
  }

  getAllExamswithTcId() {
    const tcID = localStorage.getItem("testCenterId");
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallexams?tcId=" +
      tcID
    );
  }

  getAllExamswithTcIdForTech(tcId) {
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallexams?tcId=" +
      tcId +
      "&type=tech"
    );
  }

  getAllExamswithProcedure() {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallexamswithprocedure?tcId=" +
      tcID,
      { headers: header }
    );
  }

  getExams() {
    return this.http.get(
      environment.resourceURL + this.generalcontextpath + "/getexams"
    );
  }

  getAllEquipmentsByTc(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallequipmentsbytc?testCenterId=" +
      data.testCenterId + "&currentdate=" + this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
      { headers: header }
    );
  }

  getpatientbyid(id) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientbyid?id=" +
      id,
      { headers: header }
    );
  }

  getAllEquipmentsBTcCalendar(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallequipmentsbytc?testCenterId=" +
      data.testCenterId +
      "&available=" +
      data.available +
      "&currentdate=" +
      this.datepipe.transform(new Date(), "yyyy-MM-dd"),
      { headers: header }
    );
  }

  getallbodypartsbyexamidWithTcId(data) {
    const tcID = localStorage.getItem("testCenterId");
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallbodypartsbyexamid?examId=" +
      data.examId +
      "&tcId=" +
      tcID
    );
  }

  getallbodypartsbyexamid(data) {
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallbodypartsbyexamid?examId=" +
      data.examId
    );
  }
  removeTcEquipment(data) {
    const header = this.authHeader();
    return this.http.put(
      environment.resourceURL + this.profilecontextpath + "/removetcequipment",
      data,
      { headers: header }
    );
  }
  changeavailabletcequipment(data) {
    const header = this.authHeader();
    return this.http.put(
      environment.resourceURL +
      this.profilecontextpath +
      "/changeavailabletcequipment",
      data,
      { headers: header }
    );
  }

  saveTcEquipments(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/addorupdatetcequipments",
      data,
      { headers: header }
    );
  }
  getallproceduresbybodypartByTcId(data) {
    const tcID = localStorage.getItem("testCenterId");
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallproceduresbybodypartid?bodypartId=" +
      data.bodypartId +
      "&tcId=" +
      tcID
    );
  }

  getallproceduresbybodypart(data) {
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallproceduresbybodypartid?bodypartId=" +
      data.bodypartId
    );
  }
  removetcprocedure(data) {
    const header = this.authHeader();
    return this.http.put(
      environment.resourceURL + this.profilecontextpath + "/removetcprocedure",
      data,
      { headers: header }
    );
  }

  addorupdateprocedure(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/addorupdatetcprocedures",
      data,
      { headers: header }
    );
  }

  addorupdatemedicalqn(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/addorupdatemedicalquestions",
      data,
      { headers: header }
    );
  }

  addorupdateschedmedicalquestions(data) {
    const header = new HttpHeaders({
      ContentType: "application/json",
    });
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/addorupdateschedmedicalquestions",
      data,
      { headers: header }
    );
  }
  getallprocedurebytc(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallprocedurebytc?testCenterId=" +
      data.testCenterId,
      { headers: header }
    );
  }
  registerTechnician(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/registertechnician",
      data,
      { headers: header }
    );
  }

  updateTechnician(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.put(
      environment.resourceURL + this.profilecontextpath + "/updatetechnician",
      data,
      { headers: header }
    );
  }

  update(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/updatephysician",
      data,
      { headers: header }
    );
  }

  updatefrontDesk(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.put(
      environment.resourceURL + this.profilecontextpath + "/updatefrontDesk",
      data,
      { headers: header }
    );
  }

  getAllTechnicianByTestCenter(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechnicianbytestcenterid?testcenterId=" +
      data.testcenterId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType,
      { headers: header }
    );
  }

  getAllTerminateTechnicianByTestCenter(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechnicianbytestcenterid?testcenterId=" +
      data.testcenterId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&type=terminatetech",
      { headers: header }
    );
  }

  getTechnicianByTechnicianId(techId) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/viewtechnician?technicianId=" +
      techId,
      { headers: header }
    );
  }

  getTechnicianByTechnicianIdwithType(techId, type) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/viewtechnician?technicianId=" +
      techId +
      "&type=" +
      type,
      { headers: header }
    );
  }

  deleteTechinicanByTechnicianId(techId) {
    const header = this.authHeader();
    return this.http.delete(
      environment.resourceURL +
      this.profilecontextpath +
      "/deletetechnician?technicianId=" +
      techId,
      { headers: header }
    );
  }

  deleteMedicalQn(tcMedicalQuestionid) {
    const header = this.authHeader();
    return this.http.delete(
      environment.resourceURL +
      this.profilecontextpath +
      "/deletemedicalquestion?tcMedicalQuestionid=" +
      tcMedicalQuestionid,
      { headers: header }
    );
  }

  getmedicalquestions(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getmedicalquestions?testCenterId=" +
      data.testCenterId +
      "&cptCode=" +
      data.cptCode +
      "&defaults=" +
      data.defaults,
      { headers: header }
    );
  }

  registerFrontDesk(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/registerfrontdesk",
      data,
      { headers: header }
    );
  }

  getAllFrontDeskByTestCenter(data) {
    const header = this.authHeader();
    // return this.http.get(environment.resourceURL + this.profilecontextpath + "/getfrontdeskbytestcenterid?testcenterId=" + data.testcenterId + '&pageNumber=' + data.pageNumber + '&pageSize=' + data.pageSize + '&sortColumn=' + data.sortColumn + '&sortType=' + data.sortType, { headers: header });
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getfrontdeskbytestcenterid?testcenterId=" +
      data.testcenterId,
      { headers: header }
    );
  }

  getFrontDeskByFrontDeskId(frontDeskId) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/viewfrontdesk?frontdeskId=" +
      frontDeskId,
      { headers: header }
    );
  }

  deleteFrontDesk(frontDeskId) {
    const header = this.authHeader();
    return this.http.delete(
      environment.resourceURL +
      this.profilecontextpath +
      "/deletefrontdesk?frontdeskId=" +
      frontDeskId,
      { headers: header }
    );
  }

  addorupdatevacationrequest(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/addorupdatevacationrequest",
      data,
      { headers: header }
    );
  }

  getalltechvacationbyid(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechvacationbyid?technicianId=" +
      data.technicianId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize +
      "&statusList" +
      data.statusList,
      { headers: header }
    );
  }

  getallinsurancebycountryByTcId(data) {
    const tcID = localStorage.getItem("testCenterId");
    const countryId = this.mapInsuranceApiCountryId(data.countryId);
    const header = this.contentTypeAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallinsurancebycountry?countryId=" +
      countryId +
      "&tcId=" +
      tcID,
      { headers: header }
    );
  }



  getallinsurancebycountry(data) {
    const countryId = this.mapInsuranceApiCountryId(data.countryId);
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      ContentType: "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "Bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallinsurancebycountry?countryId=" +
      countryId,
      { headers: header }
    );
  }

  addorupdateTCinsurance(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/addorupdateTCinsurance",
      data,
      { headers: header }
    );
  }

  viewTCinsurance(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/viewTCinsurance?testcenterid=" +
      data.testcenterid,
      { headers: header }
    );
  }

  deleteTCinsurance(id) {
    const header = this.contentTypeAuthHeader();
    return this.http.put(
      environment.resourceURL +
      this.profilecontextpath +
      "/deleteTCinsurance?tcinsuranceid=" +
      id,
      {},
      { headers: header }
    );
  }

  deleteuploadedphotos(tcProfilePhotoId) {
    const header = this.authHeader();
    return this.http.put(
      environment.resourceURL +
      this.profilecontextpath +
      "/deleteuploadedphotos?tcProfilePhotoId=" +
      tcProfilePhotoId,
      {},
      { headers: header }
    );
  }

  getalluploadedpicsbytc(testCenterId) {
    const header = new HttpHeaders();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalluploadedpicsbytc?testCenterId=" +
      testCenterId,
      { headers: header }
    );
  }

  getallapprovedvacation(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallapprovedvacation?technicianId=" +
      data.technicianId,
      { headers: header }
    );
  }

  checkDialCode(dialCode): string {
    if (dialCode && dialCode.toString().trim() && dialCode == "+91") {
      return environment.indiaPhoneMask;
    } else if (dialCode && dialCode.toString().trim() && dialCode == "+1") {
      return environment.usPhoneMask;
    }
    return null;
  }

  getCredential(file): any {
    const extenstion = file.name.split(".");
    const credentials = {
      fileExtenstion: extenstion[1],
      fileName: file.name,
    };
    return credentials;
  }

  getParams(file, fileDetails): any {
    const params = {
      Bucket: environment.s3Bucket,
      Key:
        environment.s3Folder +
        Math.floor(Math.random() * 100000) +
        Date.now().toString() + "." +
        fileDetails.fileExtenstion,
      Body: file,
    };
    return params;
  }

  awsUploadFile(file): string {
    let flag = false;
    let key = "";
    AWS.config.region = environment.awsRegion; // 1. Enter your region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsIdentityPoolId, // 2. Enter your identity pool
    });

    if (file) {

      const fileDetails = this.getCredential(file);
      const params = this.getParams(file, fileDetails);
      const Obj = this;
      const bucket = new S3({ params: { Bucket: params.Bucket } });
      bucket
        .upload(params)
        .on("httpUploadProgress", function (evt) {
          this.uploadPercentage = (evt.loaded * 100) / +evt.total;
          Obj.progressBarValue(this.uploadPercentage);
        })
        .send(function (err, response) {
          flag = true;
          key = response.key;
          return response.key;
        });
    }
    if (flag) {
      return key;
    }
  }

  remainingPercentage: any;
  progressBarValue(percentage) {
    this.remainingPercentage = percentage;
  }

  saveProfilePic(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/uploadprofilepic?",
      data,
      { headers: header }
    );
  }

  tctimeslotupdate(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/tctimeslotupdate",
      data,
      { headers: header }
    );
  }

  getAllVacationByPendingandApprovedstatus(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallviewtechvacationbyid?technicianId=" +
      data.technicianId +
      "&statusList=" +
      data.statusList +
      "&pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
      { headers: header }
    );
  }

  getcountrycodebytc() {
    const header = this.jsonUpperAuthHeader();
    return this.http.get(
      environment.resourceURL + this.profilecontextpath + "/getcountrycodebytc",
      { headers: header }
    );
  }

  addorupdatepatient(data) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/addorupdatepatient",
      data,
      { headers: header }
    );
  }

  gettestcentersbylocation(data) {
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/gettestcentersbylocation?scheduleOn=" +
      data.scheduleOn +
      "&dayOfweek=" +
      data.dayOfweek +
      "&latitude=" +
      data.latitude +
      "&longitude=" +
      data.longitude
    );
  }

  gettestcentersbycriteria(data) {
    let cptCodeUrl = "";
    if (data.cptCodes && data.cptCodes.length > 0) {
      for (let i = 0; i < data.cptCodes.length; i++) {
        cptCodeUrl = cptCodeUrl + "&cptCodes=" + data.cptCodes[i];
      }
    }
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/gettestcentersbycriteria?scheduleOn=" +
      data.scheduleOn +
      "&location=" +
      data.location +
      "&dayOfweek=" +
      data.dayOfweek +
      cptCodeUrl +
      "&payMode=" +
      data.payMode +
      "&insurance=" +
      data.insurance +
      "&inType=" +
      data.inType +
      "&latitude=" +
      data.latitude +
      "&longitude=" +
      data.longitude +
      "&today=" +
      data.today +
      "&timeZone=" +
      data.timeZone +
      "&currentTime=" +
      data.currentTime
    );
  }

  getallstatecount(data) {
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallstatecount?countryCode=" +
      data.countryCode
    );
  }

  getallcitycount(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallcitycount?stateId=" +
      data.stateId,
      { headers: header }
    );
  }

  getallareasbylatlng(data) {
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getallareasbylatlng?lat=" +
      data.latitude +
      "&lng=" +
      data.longitude
    );
  }

  getmedicalqns(id) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewtcpromedquest?id=" +
      id,
      { headers: header }
    );
  }

  getallareasbycity(city) {
    const header = this.jsonLowerAuthHeader();

    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getallareasbycity?city=" +
      city,
      { headers: header }
    );
  }
  scheduleappointment(data) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "Content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/scheduleappointment",
      data,
      { headers: header }
    );
  }
  viewscheduleappointment(id) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewscheduleappointment?id=" +
      id,
      { headers: header }
    );
  }

  viewscheduleappointmentwithcheckin(schedid, patientid, tcId) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewscheduleappointment?id=" +
      schedid +
      "&tcId=" +
      tcId +
      "&patientId=" +
      patientid,
      { headers: header }
    );
  }

  viewphysicianbyid(id) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getphysicianbyid?id=" +
      id,
      { headers: header }
    );
  }
  viewscheduleappointmentpro(id) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewscheduleappointmentpro?id=" +
      id,
      { headers: header }
    );
  }

  viewscheduleappointmentproWithFlag(id) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewscheduleappointmentpro?id=" +
      id + "&flag=false",
      { headers: header }
    );
  }


  updatescheduleappointment(data) {
    const header = new HttpHeaders();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/updatescheduleappointment",
      data,
      { headers: header }
    );
  }

  updatepreauthorize(data) {
    const header = new HttpHeaders();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/updatepreauthorize",
      data,
      { headers: header }
    );
  }

  updatenotify(data) {
    const header = new HttpHeaders();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/updatenotify",
      data,
      { headers: header }
    );
  }

  cancelAppointment(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/cancelscheduleappointment",
      data,
      { headers: header }
    );
  }

  getSearchPhysician() {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getsearchphysician?search=t&pageNumber=0&pageRecord=0",
      "",
      { headers: header }
    );
  }

  gettcschedulebydatetype(data) {
    const header = this.authJsonHeaderLowerAfter();

    const tcID = localStorage.getItem("testCenterId");
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettcschedulebydate?startDate=" +
      data.startDate +
      "&type=" +
      data.type +
      "&tcId=" +
      tcID,
      { headers: header }
    );
  }

  gettcscheduleList(data) {
    const header = this.authJsonHeaderLowerAfter();

    const tcID = localStorage.getItem("testCenterId");
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath + `/gettimeslotsbytccriteria?scheduleOn=${data.scheduleOn}&cptCodes=${data.cptCodes}&currentDate=${data.currentDate}&tcId=${tcID}&timeZone=${data.timeZone}&currentTime=${data.currentTime}`,
      { headers: header }
    );
  }

  gettcscheduleListByTc(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      `/gettimeslotsbytccriteria?scheduleOn=${data.scheduleOn}&cptCodes=${data.cptCodes}&currentDate=${data.currentDate}&tcId=${data.tcId}&timeZone=${data.timeZone}&currentTime=${data.currentTime}`,
      { headers: header }
    );
  }

  saveTechWorkHours(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/techaddorupdateworkhoursbytc",
      data,
      { headers: header }
    );
  }

  getTechWorkHours(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechworkhourbytc?techId=" +
      data.techId,
      { headers: header }
    );
  }

  deleteOneTechWorkHour(id) {
    const header = this.authHeader();
    return this.http.delete(
      environment.resourceURL +
      this.profilecontextpath +
      "/deletetechworkhoursbytc?id=" +
      id,
      { headers: header }
    );
  }

  getAllTechWorkHoursData() {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechworkhourbytc",
      { headers: header }
    );
  }

  patientCheckin(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/patientcheckin",
      data,
      { headers: header }
    );
  }

  // Paypal

  getaccesstoken(countryId) {
    const header = new Headers();
    var token = null;
    if (countryId === "US") {
      token = environment.paypalBasicAuthUS;
    } else {
      token = environment.paypalBasicAuthIN;
    }

    header.append("Content-Type", "application/x-www-form-urlencoded");
    header.append("Authorization", "Basic " + token);
    // let body = new URLSearchParams();
    const value = "client_credentials";
    const body = `grant_type=${value}`;
    return this.https
      .post("https://api.sandbox.paypal.com/v1/oauth2/token", body, {
        headers: header,
      })
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  savecard(data, accesstoken) {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Authorization", "bearer " + accesstoken);
    return this.https
      .post("https://api.sandbox.paypal.com/v1/vault/credit-cards/", data, {
        headers: header,
      })
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  getCardinfo(paypalId, accesstoken) {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Authorization", "bearer " + accesstoken);
    return this.https
      .get("https://api.sandbox.paypal.com/v1/vault/credit-cards/" + paypalId, {
        headers: header,
      })
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  updatecard(data, paypalId, accesstoken) {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Authorization", "bearer " + accesstoken);
    return this.https
      .patch(
        "https://api.sandbox.paypal.com/v1/vault/credit-cards/" + paypalId,
        data,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  deleteCard(paypalId, accesstoken) {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Authorization", "bearer " + accesstoken);
    return this.https
      .delete(
        "https://api.sandbox.paypal.com/v1/vault/credit-cards/" + paypalId,
        { headers: header }
      )
      .pipe(
        map((res) => {
          return res.json();
        })
      );
  }

  getAllPatient() {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientbytcid?tcId=" +
      tcID,
      { headers: header }
    );
  }

  getcardList(tcID) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      `/getalltccarddetails?tcId=${tcID}`,
      { headers: header }
    );
  }

  addOrUpdateCard(params) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL + this.paycontextpath + `/addorupdatecarddetails`,
      params,
      { headers: header }
    );
  }

  removeCard(deleteID) {
    const header = this.authHeader();
    return this.http.delete(
      environment.resourceURL +
      this.paycontextpath +
      "/deletetccarddetails?id=" +
      deleteID,
      { headers: header }
    );
  }

  getCardByID(cardID) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      `/gettccarddetails?id=${cardID}`,
      { headers: header }
    );
  }

  getPlanList(tcID) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      `/gettcsubscription?tcId=${tcID}`,
      { headers: header }
    );
  }

  addPlanList(params) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.paycontextpath +
      `/addorupdatetcsubscription`,
      params,
      { headers: header }
    );
  }

  getPatientScheduleList(patientID) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      `/getpatientscheduledappointmentlist?id=${patientID}`,
      { headers: header }
    );
  }

  noshowschedule(params) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      `/noshowscheduleappointment`,
      params,
      { headers: header }
    );
  }

  cancelscheduleByCode(params) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      `/cancelscheduleappointmentbycode`,
      params,
      { headers: header }
    );
  }

  cancelschedule(params) {
    const header = this.jsonLowerAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      `/cancelscheduleappointment`,
      params,
      { headers: header }
    );
  }

  getPatientCancelData(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewcancelscheduleappointment?tcId=" +
      data.tcId +
      "&patientId=" +
      data.patientId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize,
      { headers: header }
    );
  }

  getPatientNoShowData(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewnoshowscheduleappointment?tcId=" +
      data.tcId +
      "&patientId=" +
      data.patientId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize,
      { headers: header }
    );
  }

  getAllPatientByTcId(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientbytcid?tcId=" +
      data.tcId,
      { headers: header }
    );
  }

  getAllTechnicianByTcId(data) {
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechnicianbytestcenterid?testcenterId=" +
      data.testcenterId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageSize=" +
      data.pageSize +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType,
      { headers: header }
    );
  }
  holdSubscription(params) {
    const header = this.jsonLowerAuthHeader();

    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      `/holdorcancelsubscription?${params}`,
      { headers: header }
    );
  }

  scheduleWaitingList(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/schedulewaiting",
      data,
      { headers: header }
    );
  }

  getavailabletechnicianhomecal(id) {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.jsonUpperAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getavailabletechnicianhomecal?tcId=" +
      tcID +
      "&scheduleId=" +
      id,
      { headers: header }
    );
  }

  assigntechnicianforschedule(techId, schedId) {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/assigntechnicianforschedule?techId=" +
      techId +
      "&scheduleId=" +
      schedId,
      null,
      { headers: header }
    );
  }

  getAllWorkHoursTechnician() {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getalltechworkhoursbytechid",
      { headers: header }
    );
  }

  getSelfAmount(data) {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getscheduleamountbytcid?tcId=" +
      tcID +
      "&cptcode=" +
      data.cptcode +
      "&payMode=" +
      data.payMode,
      { headers: header }
    );
  }

  getpatientlistbytc(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientlistbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&patientType=" +
      data.patientType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getpatientlistbytcWithFilter(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientlistbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&patientType=" +
      data.patientType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid,
      { headers: header }
    );
  }

  getpatientlistbytcReport(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientlistbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&patientType=" +
      data.patientType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  downloadPatientLogPdf(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getuserreportbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&patientType=" +
      data.patientType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId +
      "&type=" +
      data.type +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllWeekOff(data) {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getallweekofbytcid?tcId=" +
      tcID +
      "&startDate=" +
      data.startDate,
      { headers: header }
    );
  }

  sendMessages(data) {
    const header = this.jsonUpperAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/sendsmsandemaillinkbyfrontdesc?id=" +
      data.id +
      "&msgType=" +
      data.msgType,
      null,
      { headers: header }
    );
  }

  getPhysicianListbytc(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getphysicianlistbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId,
      { headers: header }
    );
  }
  getAllInsurenceBilling(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getinsurancebilling",
      { headers: header, params: data }
    );
  }

  getAllInsurenceBillingBYTcId(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getinsurancebillingbytc2",
      { headers: header, params: data }
    );
  }


  getAllInsurenceBillingReport(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getinsurancebillingreport",
      { headers: header, params: data }
    );
  }

  getPhysicianListbytcReport(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getphysicianlistbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&search=" +
      data.search +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }
  savePdf(pdfFile) {
    const fileName = pdfFile.substring(
      pdfFile.lastIndexOf("/"),
      pdfFile.length
    );
    const URLToPDF = pdfFile;
    const header = new HttpHeaders({
      Accept: "application/pdf",
      Authorization: "Bearer " + localStorage.getItem("accesstoken"),
    });
    this.pdfHttp
      .get(URLToPDF, { headers: header, responseType: "blob" })
      .subscribe((res: any) => {
        const file = new Blob([res], {
          type: "application/pdf",
        });
        saveAs(file, fileName);
      }, () => {
        return;
      });
  }
  getScheduleByType(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL + this.schedulecontextpath + "/getschedulebytype",
      { headers: header, params: data }
    );
  }

  etScheduleByTypeCheckin(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getschedulebycheckedin",
      { headers: header, params: data }
    );
  }

  getScheduleReportByType(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getschedulereportbytype",
      { headers: header, params: data }
    );
  }
  getVisitingHistory(obj) {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientvisitinghistory?tcId=" +
      tcID +
      "&patientId=" +
      obj.patientId +
      "&type=" +
      obj.type,
      { headers: header }
    );
  }

  getAuthoStatus(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientauthbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortColumn=" +
      data.sortColumn +
      "&sortType=" +
      data.sortType +
      "&tcId=" +
      data.tcId +
      "&preAuth=" +
      data.preAuth +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getTechLogReport(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/gettechlogbytc?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }
  getAllReviewByTc(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewallreviewratingbytype",
      { headers: header, params: data }
    );
  }
  getAllMachineByExamId(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallmachinebyexamid",
      { headers: header, params: data }
    );
  }
  cancelScheduleAppointmentByMachine(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/cancelscheduleappointmentbytype",
      data,
      { headers: header }
    );
  }
  getIcscheduleCancel(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/geticcancelschedulehistory",
      { headers: header, params: data }
    );
  }
  getBillingHistory(data) {
    const header = this.authJsonHeaderLowerAfter();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      "/getpatientbillinghistory?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&tcId=" +
      data.tcId +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate +
      "&procedureId=" +
      data.procedureId +
      "&type=" +
      data.feesType,
      { headers: header }
    );
  }
  postReviews(data) {
    const header = this.contentTypeAuthHeader();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/addorupdatereview",
      data,
      { headers: header }
    );
  }
  getAllPatientByType() {
    const tcID = localStorage.getItem("testCenterId");
    const header = this.jsonLowerAuthHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getpatientbytcid?tcId=" +
      tcID +
      "&&type=schedule",
      { headers: header }
    );
  }

  getAllPatientsListAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getpatientlistadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAllTechniciansListAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettechnicianlistadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllTechniciansListAdminWithFilter(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettechnicianlistadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllDoctorsListAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getphysicianlistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllDoctorsListAdminWithFilter(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getphysicianlistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllTCListAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettclistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAllTCListAdminWithFilter(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettclistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAllInsuranceListAdmin(data: any): any {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "Content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallinsuranceadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAllInsuranceListAdminWithFilter(data: any): any {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "Content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallinsuranceadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&countryid=" +
      data.countryid +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getDashboardCountAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/dashboardcount?startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getReserveDashboardCountAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/dashboardreservecount?startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      { headers: header }
    );
  }

  getAllManageTCListAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getmanagetclistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAllManageTCListAdminwithFilter(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getmanagetclistbyadmin?pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  changeHoldStatusAdmin(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/holdorunholdtc?tcId=" +
      data.tcId +
      "&active=" +
      data.active,
      { headers: header }
    );
  }

  getallappointments(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallappointmentscount?type=" +
      data.type +
      "&tcid=" +
      data.tcid +
      "&date=" +
      data.date,
      { headers: header }
    );
  }

  getUtilizationByType(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getutilizationreport?type=" +
      data.type +
      "&date=" +
      data.date +
      "&tcId=" +
      data.tcId +
      "&view=" +
      data.view +
      "&strDate=" +
      data.strDate,
      { headers: header }
    );
  }

  getallexamcount(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/getallexamcount?type=" +
      data.type +
      "&tcid=" +
      data.tcid,
      { headers: header }
    );
  }

  getCallOfSchedMed(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getallschedcallbytc?tcId=" +
      data.tcId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord,
      { headers: header }
    );
  }

  getBillingApprovedReport(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      "/getbillinghistorybyadmin?type=" +
      data.type +
      "&pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getBillingApprovedReportWithFilter(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.paycontextpath +
      "/getbillinghistorybyadmin?type=" +
      data.type +
      "&pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&countryid=" +
      data.countryid +
      "&stateid=" +
      data.stateid +
      "&search=" +
      data.search,
      { headers: header }
    );
  }

  getAccessManagement() {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettcaccessmanagement",
      { headers: header }
    );
  }

  getFrontDeskAccessManagement() {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettcaccessmanagement",
      { headers: header }
    );

  }

  getAccess() {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.profilecontextpath +
      "/gettcaccessmanagementbyid",
      { headers: header }
    );
  }

  updateaccessmanagement(data) {
    const header = this.authHeader();
    return this.http.post(
      environment.resourceURL +
      this.profilecontextpath +
      "/savetcaccessmanagement",
      data,
      { headers: header }
    );
  }

  checklength(value) {
    if (value && value.toString().length > 1) {
      return value;
    } else if (value) {
      return "0" + value;
    }
    return "0";
  }

  getnoshowCount(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getnoshowcount?tcId=" +
      data.tcId +
      "&date=" +
      data.date,
      { headers: header }
    );
  }

  getalltcwaitinglist(data: any): any {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getalltcwaitinglist?tcId=" +
      data.tcId +
      "&pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&search=" +
      data.search
      + "&searchDate=" + data.searchDate
      + "&searchFromTime=" + data.searchFromTime
      + "&searchToTime=" + data.searchToTime,
      { headers: header }
    );
  }

  getTimeZoneByLatLng(lat, lng) {
    const url =
      "https://maps.googleapis.com/maps/api/timezone/json?location=" +
      lat +
      "," +
      lng +
      "&timestamp=" +
      Date.now() / 1000 +
      "&key=" +
      environment.googleKey;
    return this.http.get(url);
  }

  getNotifcationContent(tcId, preAuth) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.notificationcontextpath +
      "/getallpatienttextemail?tcId=" +
      tcId +
      "&preauthorized=" +
      preAuth,
      { headers: header }
    );
  }

  savepatientTextMessage(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.notificationcontextpath +
      "/addOrUpdatePatientTextEmail",
      data,
      { headers: header }
    );
  }

  getMedicalQuestionByCptcode(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewtcpromedquestic",
      data,
      { headers: header }
    );
  }

  getallexamdandprocedureandbodypartbycptcode(data) {
    const header = this.authHeader();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getallexamdandprocedureandbodypartbycptcode?tcId=" +
      data.tcId +
      "&cptcode=" +
      data.cptcode,
      { headers: header }
    );
  }

  getallexamdandprocedureandbodypartbycptcodeForhome(data) {
    const header = new HttpHeaders();
    return this.http.get(
      environment.resourceURL +
      this.generalcontextpath +
      "/getalldefaultexamandprocedureandbodypartbycptcode?cptcode=" +
      data.cptcode,
      { headers: header }
    );
  }

  updateArrivedStatus(status, id) {
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/makepatientarrived?patientArrived=" +
      status +
      "&id=" +
      id
    );
  }

  checkPatientCode(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/patientcode",
      data,
      { headers: header }
    );
  }

  updateschedinsurance(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/updateschedinsurance",
      data,
      { headers: header }
    );
  }

  scheduleInsuranceList(id) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getschedinsurancelistbytype?id=" +
      id +
      "&type=sched",
      { headers: header }
    );
  }

  updateWaitingList(id) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/udpatewaitinglist?id=" +
      id,
      "",
      { headers: header }
    );
  }

  viewMessageCenter(fromDate, todate) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/viewmessagecenter?fromDate=" +
      fromDate +
      "&toDate=" +
      todate +
      "&tcid=" +
      localStorage.getItem("testCenterId"),
      { headers: header }
    );
  }
  checkGivenDateIsHolidayOrNot(datestr) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/checkholidaybytc?tcid=" +
      localStorage.getItem("testCenterId") +
      "&datestr=" +
      datestr,
      "",
      { headers: header }
    );
  }

  checkGivenDateIsHolidayOrNotByTcid(datestr, tcid) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/checkholidaybytc?tcid=" +
      tcid +
      "&datestr=" +
      datestr,
      "",
      { headers: header }
    );
  }

  getgriddata(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getgriddata?fromDate=" +
      data.fromDate +
      "&toDate=" +
      data.toDate +
      "&type=" +
      data.type +
      "&pageNumber=" +
      data.pageNumber +
      "&pageRecord=" +
      data.pageRecord +
      "&search=" +
      data.search +
      "&sortType=" +
      data.sortType +
      "&sortColumn=" +
      data.sortColumn +
      "&tcid=" +
      localStorage.getItem("testCenterId"),
      { headers: header }
    );
  }

  ratingCount(tcid) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/reviewratingbycount?tcid=" +
      tcid +
      "&type=patient",
      { headers: header }
    );
  }

  getCalendarURL(id) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getcalendarurl?id=" +
      id,
      { headers: header }
    );
  }

  prescriptionupload(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL +
      this.schedulecontextpath +
      "/prescriptionupload",
      data,
      { headers: header }
    );
  }

  schedPrescription(id) {
    const token = localStorage.getItem("accesstoken");
    const headersConfig: any = {
      "Content-Type": "application/json",
    };
    if (token && token !== "null" && token !== "undefined") {
      headersConfig.Authorization = "bearer " + token;
    }
    const header = new HttpHeaders(headersConfig);
    return this.http.get(
      environment.resourceURL +
      this.schedulecontextpath +
      "/getprescription?id=" +
      id,
      { headers: header }
    );
  }

  updateTimeZone(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/updatetimezone",
      data,
      { headers: header }
    );
  }

  deleteCancelScheduleBytype(id) {
    const header = new HttpHeaders({
      Authorization: "bearer " + localStorage.getItem("accesstoken")
    });
    return this.http.delete(
      environment.resourceURL + this.schedulecontextpath + "/deletecancelscheduleappointmentbytype?id=" + id + "&type=delete",
      { headers: header }
    );
  }

  updateAppointmentAmount(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/updateappointmentamount?id=" + data.id + "&amount=" + data.amount,
      "",
      { headers: header }
    );
  }

  getNotification(data) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.get(
      environment.resourceURL + this.schedulecontextpath + "/getschedulenotification?tcId=" + data.tcId + "&pageNumber=" + data.pageNumber + "&pageRecord=" + data.pageRecord,
      { headers: header }
    );
  }

  readNotification(id) {
    const header = this.authJsonHeaderUpperAfter();
    return this.http.post(
      environment.resourceURL + this.schedulecontextpath + "/readnofication?id=" + id,
      { headers: header }
    );
  }

  acceptInsurance(data) {
    const header = new HttpHeaders({
      Authorization: "bearer " + localStorage.getItem("accesstoken")
    });
    return this.http.post(
      environment.resourceURL + this.profilecontextpath + "/updateinsuranceacceptance?testCenterId=" + data.testcenterid + "&acceptance=" + data.acceptance, '', { headers: header }
    );
  }
}
